import { ApiV2 } from "../Api";
import DateUtil from "./../../utils/Date";

export default class MaintenanceSchedule {
  async create({ data, token }) {
    const response = await ApiV2.post("/maintenanceSchedule", data, {
      headers: {"Authorization": "bearer " + token}
    }).then(response => {
      return response.data;
    }).catch(error => {
      try {
        if (error.response.data === "Unauthorized") {
          return {
            success: false,
            error: {
              type: "UnauthorizedError",
              details: [{
                message: "UnauthorizedError"
              }]
            }
          };
        }
        return error.response.data;
      }
      catch(error) {
        return {
          success: false,
          error: {
            type: "NetworkError",
            details: [{
              message: "NetworkError"
            }]
          }
        };
      }
    });
    return response;
  }

  async findAllGrid({ data, token }) {
    const response = await ApiV2.post("/maintenanceSchedule/find/all", data, {
      headers: {"Authorization": "bearer " + token}
    }).then(response => {
      return response.data;
    }).catch(error => {
      try {
        if (error.response.data === "Unauthorized") {
          return {
            success: false,
            error: {
              type: "UnauthorizedError",
              details: [{
                message: "UnauthorizedError"
              }]
            }
          };
        }
        return error.response.data;
      }
      catch(error) {
        return {
          success: false,
          error: {
            type: "NetworkError",
            details: [{
              message: "NetworkError"
            }]
          }
        };
      }
    });
    if (response.success) return this.findAllGridTranslate({ data: response.data });
    return this.findAllGridTranslate({ data: {
      docs: [],
      limit: 1,
      page: 1,
      pages: false
    }});
  }

  findAllGridTranslate({ data }) {
    data.cols = [{
      width: "30%",
      type: "string",
      label: "Title.Client"
    }, {
      width: "30%",
      type: "string",
      label: "Title.BoardOrName"
    }, {
      width: "15%",
      type: "string",
      label: "Title.Date.Start"
    }, {
      width: "15%",
      type: "string",
      label: "Title.Date.End"
    }, {
      width: "10%",
      type: "string",
      label: "Title.Status"
    }];
    data.rows = [];
    data.docs.map(item => {
      const itemAux = [
        {
          value: this.findAllGridTranslateItem({ data: item, item: "client" }) !== undefined ? (item.client.type === "LEG" ? item.client.legal.socialReason : item.client.personal.name) : ""
        },
        {
          value: this.findAllGridTranslateItem({ data: item, item: "patrimony.description" }) !== undefined ? item.patrimony.description : ""
        },
        {
          value: this.findAllGridTranslateItem({ data: item, item: "dateStart" }) !== undefined ? DateUtil.to({ date: new Date(item.dateStart), format: "DD/MM/YYYY HH:mm:ss", tz: "America/Sao_Paulo"}) : ""
        },
        {
          value: this.findAllGridTranslateItem({ data: item, item: "dateEnd" }) !== undefined ? DateUtil.to({ date: new Date(item.dateEnd), format: "DD/MM/YYYY HH:mm:ss", tz: "America/Sao_Paulo"}) : ""
        },
        {
          value: this.findAllGridTranslateItem({ data: item, item: "status" }) !== undefined ? item.status : ""
        }
      ];
      return data.rows.push(itemAux);
    });
    return data;
  }

  findAllGridTranslateItem({ data, item }) {
    try {
      var itemAux = item.split(".");
      var dataAux = data;
      itemAux.map(it => {
        return dataAux = dataAux[it];
      });
      return dataAux;
    }
    catch (e) {
      return false;
    }
  }

  async update({ id, data, token }) {
    const response = await ApiV2.put(`/maintenanceSchedule/${id}`, data, {
      headers: {"Authorization": "bearer " + token}
    }).then(response => {
      return response.data;
    }).catch(error => {
      try {
        if (error.response.data === "Unauthorized") {
          return {
            success: false,
            error: {
              type: "UnauthorizedError",
              details: [{
                message: "UnauthorizedError"
              }]
            }
          };
        }
        return error.response.data;
      }
      catch(error) {
        return {
          success: false,
          error: {
            type: "NetworkError",
            details: [{
              message: "NetworkError"
            }]
          }
        };
      }
    });
    return response;
  }
}
